import { HIDE_PROJECTS_INTERNAL_ID } from 'common/constants';
import { useHideSomeExperiment } from './use-hide-some-experiment';

export function useHideProjects() {
  return useHideSomeExperiment(HIDE_PROJECTS_INTERNAL_ID);
}
